// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3d7577b5","977":"5da05dd8"}[chunkId] + ".chunk.js";
};